export default __webpack_public_path__ + "static/media/Siddhanta.ce3a18de.png";